// Add all JS development here
jQuery(function ($) {
    $(document).ready(function () {

        //Navbar Scrollspy 
        $(window).scroll(function () {
            var scroll = $(window).scrollTop();
            if (scroll > 80) {
                $(".inner").addClass("affix");
            } else {
                $(".inner").removeClass("affix");
            }
        });

        //Close Menu while scroll
        $(window).scroll(function () {
            var scroll = $(window).scrollTop();
            if (scroll > 10) {
                $('.dropdown-toggle').dropdown('hide');
            }
        });


        //AOS animation
        AOS.init({
            once: true,
        });

        //Navbar Close after click
        // $(document).on('click', function () {
        //     $('.navbar .collapse').collapse('hide');
        // })

        //Mobile Menu hamburger
        $(".hamburger").click(function () {
            $(this).toggleClass("is-active");
        })

        //*******Video Play popup******//
        var $videoSrc;
        $('.video-btn').click(function () {
            $videoSrc = $(this).data("src");
        });
        console.log($videoSrc);

        // when the modal is opened autoplay it  
        $('#myModal').on('shown.bs.modal', function (e) {

            // set the video src to autoplay and not to show related video. Youtube related video is like a box of chocolates... you never know what you're gonna get
            $("#video").attr('src', $videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0");
        })

        // stop playing the youtube video when I close the modal
        $('#myModal').on('hide.bs.modal', function (e) {
            // a poor man's stop video
            $("#video").attr('src', $videoSrc);
        })


        //Header Search Icon
        $(".btn-search").click(function () {
            $(".search-form").toggle();
            $("#searchbox").focus();
        })


        //Hero Slider
        $('.hero-slider').owlCarousel({
            loop: true,
            margin: 0,
            nav: false,
            dots: true,
            lazyLoad: true,
            transitionStyle: "fade",
            animateOut: 'animate__fadeOutLeft',
            animateIn: 'animate__fadeIn',

            slideTransition: 'linear',
            // slideTransition: 'ease-in-out',
            autoplay: true,
            autoplayTimeout: 15000,
            autoplaySpeed: 1000,
            smartSpeed: 450,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 1
                },
                1000: {
                    items: 1
                }
            }
        });

        //Product & Services Slider
        var $owl = $('.product-service-slider');

        $owl.children().each(function (index) {
            $(this).attr('data-position', index); // NB: .attr() instead of .data()
        });

        $owl.owlCarousel({
            loop: true,
            margin: 5,
            lazyLoad: true,
            transitionStyle: "fade",
            animateOut: 'animate__fadeOutLeft',
            animateIn: 'animate__fadeIn',

            slideTransition: 'ease',
            autoplay: true,
            autoplayTimeout: 7000,
            autoplaySpeed: 800,
            smartSpeed: 450,
            onInitialized: counter, //When the plugin has initialized.
            onTranslated: counter, //When the translation of the stage has 
            responsive: {
                0: {
                    items: 1,
                    nav: true,
                    navText: ["<div class='prev-slide'></div>", "<div class='next-slide'></div>"],
                    dots: false,
                    dotsEach: 2
                },
                768: {
                    items: 2,
                    nav: true,
                    navText: ["<div class='prev-slide'></div>", "<div class='next-slide'></div>"],
                    dots: false,
                    dotsEach: 2
                },
                992: {
                    items: 3,
                    nav: true,
                    navText: ["<div class='prev-slide'></div>", "<div class='next-slide'></div>"],
                    dots: false,
                    dotsEach: 2
                },
                1200: {
                    center: true,
                    items: 3,
                    nav: true,
                    navText: ["<div class='prev-slide'></div>", "<div class='next-slide'></div>"],
                    dots: false,
                    dotsEach: 2
                }
            }
        });
        // $(document).on('click', '.owl-item>div', function () {
        //     var $speed = 300; // in ms
        //     $owl.trigger('to.owl.carousel', [$(this).data('position'), $speed]);
        // });

        function counter(event) {
            var element = event.target; // DOM element, in this example .owl-carousel
            var items = event.item.count; // Number of items
            var item = event.item.index + 1; // Position of the current item
            // it loop is true then reset counter from 1
            if (item > items) {
                item = item - items
            }
            $('#counter').html("<p>" + item + " / <span>" + items + "</span></p>")
        }

        //Client logo slider
        $('.client-logo-slider').owlCarousel({
            loop: true,
            margin: 10,
            nav: false,
            dots: true,
            lazyLoad: true,
            transitionStyle: "fade",
            animateOut: 'animate__fadeOutLeft',
            animateIn: 'animate__fadeIn',

            slideTransition: 'linear',
            // slideTransition: 'ease-in-out',
            autoplay: true,
            autoplayTimeout: 5000,
            autoplaySpeed: 800,
            smartSpeed: 450,
            responsive: {
                0: {
                    items: 2,
                    dotsEach: 2
                },
                600: {
                    items: 3
                },
                1000: {
                    items: 4
                }
            }
        });

        //Vaccancy slider
        $('.vaccany-slider').owlCarousel({
            loop: true,
            margin: 10,
            nav: false,
            lazyLoad: true,
            transitionStyle: "fade",
            animateOut: 'animate__fadeOutLeft',
            animateIn: 'animate__fadeIn',
            slideTransition: 'linear',
            autoplay: false,
            autoplayTimeout: 5000,
            autoplaySpeed: 800,
            smartSpeed: 450,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 1
                },
                1000: {
                    items: 1
                }
            }
        });

        //Webinar Slider
        $('.webinar-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
        });
        var $status = $('.pagingInfo');
        var $slickElement = $('.speaker-slider');
        $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            var i = (currentSlide ? currentSlide : 0) + 1;
            $status.text(i + '/' + slick.slideCount);
        });
        $slickElement.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
        });

        //Culture Slider
        var $owlcl = $('.culture-slider');
        $owlcl.children().each(function (index) {
            $(this).attr('data-position', index); // NB: .attr() instead of .data()
        });

        $owlcl.owlCarousel({
            margin: 5,
            loop: true,
            nav: true,
            lazyLoad: true,
            transitionStyle: "fade",
            animateOut: 'animate__fadeOutLeft',
            animateIn: 'animate__fadeIn',
            slideTransition: 'linear',
            autoplay: true,
            autoplayTimeout: 5000,
            autoplaySpeed: 800,
            smartSpeed: 450,
            responsive: {
                0: {
                    center: false,
                    items: 1,
                    nav: true,
                    navText: ["<div class='prev-slide'></div>", "<div class='next-slide'></div>"],
                    dots: false,
                    dotsEach: 2
                },
                600: {
                    center: false,
                    items: 2,
                    nav: true,
                    navText: ["<div class='prev-slide'></div>", "<div class='next-slide'></div>"],
                    dots: false,
                    dotsEach: 2
                },
                1000: {
                    center: true,
                    items: 5,
                    nav: true,
                    navText: ["<div class='prev-slide'></div>", "<div class='next-slide'></div>"],
                    dots: false,
                    dotsEach: 2
                }
            }
        });
        $(document).on('click', '.owl-item>div', function () {
            // see https://owlcarousel2.github.io/OwlCarousel2/docs/api-events.html#to-owl-carousel
            var $speed = 300; // in ms
            $owlcl.trigger('to.owl.carousel', [$(this).data('position'), $speed]);
        });


        //Certification & Awards Slider
        $('.cetification-award-slider').owlCarousel({
            loop: true,
            margin: 10,
            nav: false,
            dots: true,
            lazyLoad: true,
            transitionStyle: "fade",
            animateOut: 'animate__fadeOutLeft',
            animateIn: 'animate__fadeIn',
            slideTransition: 'linear',
            autoplay: true,
            autoplayTimeout: 5000,
            autoplaySpeed: 800,
            smartSpeed: 450,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 1
                },
                1000: {
                    items: 1
                }
            }
        })

        //Download form button
        jQuery(document).on("click", "#submit", function (e) {
            const fname = document.getElementById("fname").value;
            const lname = document.getElementById("lname").value;
            const email = document.getElementById("email").value;
            const number = document.getElementById("phone").value;
            const country = document.getElementById("country").value;
            if ((fname === "") && (email === "") &&
                (number === "") && (country === "country")) {
                // alert("is empty"); //put your desired code here
                document.getElementById("document").style.display = "none"
            } else {
                // alert("not empty"); //put your desired code here
                setTimeout(() => {
                    document.getElementById("document").style.display = "block"
                }, 1000);

            }
        });

    });
});


//Webinar Counter Function
// Set the date we're counting down to
var countDownDate = datetimes;
futureDate = Date.parse(countDownDate);

// Update the count down every 1 second
var x = setInterval(function () {

    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = futureDate - now;

    // Time calculations for days, hours, minutes and seconds
    var d = Math.floor(distance / (1000 * 60 * 60 * 24));
    var h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var s = Math.floor((distance % (1000 * 60)) / 1000);

    // Output the result in an element with id="demo"
    document.getElementById("days").innerHTML = d;
    document.getElementById("hours").innerHTML = h;
    document.getElementById("mins").innerHTML = m;
    document.getElementById("secs").innerHTML = s;

    // If the count down is over, write some text 
    if (distance < 0) {
        clearInterval(x);
        document.getElementById("days").innerHTML = "<span>Expired</span>";
        document.getElementById("hours").innerHTML = "<span>Expired</span>";
        document.getElementById("mins").innerHTML = "<span>Expired</span>";
        document.getElementById("secs").innerHTML = "<span>Expired</span>";
    }
}, 1000);